import { Base, withIntersectionObserver } from '@studiometa/js-toolkit';

/**
* @typedef {{}} ComponentProps
*/

/**
* Component component.
* @augments {Base<ComponentProps>}
*/
export default class Conseils extends withIntersectionObserver(Base) {
    /**
    * Class config.
    * @type {import('@studiometa/js-toolkit').BaseConfig}
    */
    static config = {
        name: 'Conseils',
        refs: ['scrolline', 'conseilsSteps', 'conseils-step'],
    };

    mounted() {
        this.$refs.scrollContainer = this.$el.querySelector('.conseils-steps');
        this.$refs.scrollline = this.$el.querySelector('.scrollline');
        this.$refs.steps = this.$el.querySelectorAll('.conseils-step');
    }

    scrolled({ y }) {
        const scrollline = this.$refs.scrollline;
        const container = this.$el.querySelector('.conseils-steps');
        const rect = container.getBoundingClientRect();

        const startOffset = window.innerHeight / 2; // Start at half screen height
        const endOffset = window.innerHeight / 2;   // 200px from bottom to end
        const windowHeight = window.innerHeight;

        const start = rect.top - startOffset - 200;
        const end = rect.bottom - (windowHeight - endOffset);

        // Progression en fonction du scroll dans la zone visible
        const totalDistance = end - start;
        const scrolledDistance = -start; // car start est négatif quand on entre

        const progress = scrolledDistance / totalDistance;
        const height = Math.max(0, Math.min(progress * 100, 100));

        scrollline.style.height = `${height}%`;

        const options = {
            root: null,
            rootMargin: '0% 0px -50% 0px', // Triggers at middle of viewport
            threshold: 0
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.opacity = '1';
                } else {
                    // Check if element is above viewport
                    const rect = entry.target.getBoundingClientRect();
                    if (rect.bottom < 0) {
                        entry.target.style.opacity = '1'; // Keep visible if scrolled past
                    } else {
                        entry.target.style.opacity = '0';
                    }
                }
            });
        }, options);

        this.$refs.steps.forEach(step => {
            observer.observe(step);
        });

    }


}
